module.exports = __webpack_public_path__ + "img/goods1.ea0ae29f.png";